import { useQuery } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import { useMemo } from 'react';
import useGraphQLClient from '../../../app/hooks/useGraphQLClient';
import { useAuthContext } from '../../auth/contexts/AuthContext';
import IDocumentTypeSub from '../interfaces/IDocumentTypeSub';
import useAppLog from '../../../app/features/log/hooks/useAppLog';

const useDocumentTypeSubs = () => {
	const authContext = useAuthContext();
	const graphQLClient = useGraphQLClient();

	const appLog = useAppLog();

	const { data, error, isFetching } = useQuery<IDocumentTypeSub[] | null, Error>(
		['documentTypeSubs'],
		async () => {
			try {
				const data = (await graphQLClient.request(
					gql`
						query {
							notificationTags {
								docType
								docSubType
								emailTag
							}
						}
					`,
				)) as { notificationTags: IDocumentTypeSub[] };
				return data.notificationTags;
			} catch (e) {
				appLog.exception(e, { component: 'useDocumentTypeSubs' });
				return null;
			}
		},
		{
			// The query will not execute until the userId exists
			enabled:
				appLog &&
				authContext.currentCompany !== null &&
				authContext.isInvestor === true &&
				authContext.isAuthenticated,
		},
	);

	return useMemo(
		() => ({
			error,
			isFetching,
			documentTypeSubs: data,
		}),
		[error, isFetching, data],
	);
};

export default useDocumentTypeSubs;
